import { withTheme } from 'styled-components'

export const HeaderIconCarInsurance = withTheme(({ theme, ...props }) =>
	theme.colorScheme === 'light' ? (
		<svg {...props} width='357' height='182' viewBox='0 0 357 182' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M50.0293 169.574C50.0293 175.262 109.629 181.862 178.324 181.862C247.018 181.862 302.697 177.249 302.697 171.562C302.697 165.874 247.005 161.274 178.324 161.274C109.642 161.274 50.0293 163.887 50.0293 169.562V169.574Z'
				fill='#FAFAFA'
			/>
			<path
				d='M0 147.451C0 65.9995 79.9179 0 178.5 0C277.082 0 357 66.0245 357 147.475L0 147.451Z'
				fill='url(#paint0_radial_1600_1387)'
			/>
			<path
				d='M166.199 152.962C166.199 71.5125 200.171 5.4873 242.084 5.4873C283.997 5.4873 317.993 71.4625 317.993 152.962H166.199Z'
				fill='url(#paint1_radial_1600_1387)'
			/>
			<path
				d='M43.1289 152.962C43.1289 71.5125 77.1002 5.4873 119.014 5.4873C160.927 5.4873 194.911 71.4625 194.911 152.962H43.1289Z'
				fill='url(#paint2_radial_1600_1387)'
			/>
			<path d='M38.0552 147.188H18.1133V118.751L28.0843 110.226L38.0552 118.751V147.188Z' fill='#E6E6E6' />
			<path d='M38.0549 118.762H49.4539L39.4829 110.237H28.084L38.0549 118.762Z' fill='#F2F2F2' />
			<path d='M35.9121 112.263V107.388H40.1836V115.913L35.9121 112.263Z' fill='#D9D9D9' />
			<path d='M38.043 147.188H49.4419V118.75H38.043V147.188Z' fill='#F2F2F2' />
			<path d='M25.4793 125.525H20.832V132.475H25.4793V125.525Z' fill='#D9D9D9' />
			<path d='M45.3836 125.525H40.7363V132.475H45.3836V125.525Z' fill='#D9D9D9' />
			<path d='M33.6707 125.525H29.0234V132.475H33.6707V125.525Z' fill='#D9D9D9' />
			<path d='M25.4793 136.076H20.832V142.601H25.4793V136.076Z' fill='#D9D9D9' />
			<path d='M45.3836 136.076H40.7363V142.601H45.3836V136.076Z' fill='#D9D9D9' />
			<path d='M33.6707 136.076H29.0234V147.238H33.6707V136.076Z' fill='#D9D9D9' />
			<path
				d='M28.1467 120.05C29.2114 120.05 30.0882 119.187 30.0882 118.112C30.0882 117.037 29.2239 116.175 28.1467 116.175C27.0694 116.175 26.2051 117.037 26.2051 118.112C26.2051 119.187 27.0694 120.05 28.1467 120.05Z'
				fill='#F2F2F2'
			/>
			<path d='M327.338 140.513H327.927V147.451H327.338V140.513Z' fill='#D9D9D9' />
			<path
				d='M330.796 109.763C331.886 109.676 332.976 109.763 334.028 110.076L334.066 116.026C333.99 116.763 334.153 117.501 334.529 118.126C335.306 119.188 336.884 119.051 338.162 119.363C338.838 119.513 339.452 119.838 339.953 120.301C340.454 120.763 340.842 121.351 341.043 122.001C341.231 122.663 341.206 123.363 340.943 124.001C340.692 124.638 340.229 125.176 339.627 125.513C338.763 125.938 337.736 125.876 336.809 126.213C334.567 126.963 333.652 129.651 333.514 132.001C333.364 134.351 333.64 136.863 332.537 138.938C331.134 141.538 327.74 142.738 324.921 141.863C323.531 141.376 322.291 140.513 321.351 139.376C320.399 138.238 319.786 136.876 319.548 135.413C319.272 133.776 319.447 132.063 318.946 130.501C318.383 128.713 317.03 126.788 318.007 125.188C318.996 123.601 322.028 123.713 322.792 121.876C323.318 120.601 322.379 119.226 322.09 117.863C321.978 117.001 322.053 116.113 322.341 115.288C322.629 114.463 323.093 113.713 323.719 113.101C326.086 110.888 328.679 109.901 330.784 109.726L330.796 109.763Z'
				fill='#F2F2F2'
			/>
			<path
				d='M88.3984 43.7125C88.2982 42.6375 87.7971 41.6375 86.9954 40.9125C86.1938 40.1875 85.1541 39.7875 84.0768 39.7875C83.3879 39.7875 82.7115 39.9625 82.1102 40.2875C81.7219 39.3 81.0454 38.45 80.1686 37.85C79.2918 37.25 78.2521 36.925 77.1873 36.925C76.3982 36.925 75.6341 37.1125 74.9326 37.45C74.3689 36.2 73.4796 35.1375 72.3647 34.35C71.2499 33.5625 69.9346 33.0875 68.5692 32.975C67.2039 32.8625 65.8385 33.1125 64.6109 33.7125C63.3833 34.3125 62.3311 35.225 61.567 36.35C60.3144 35.6125 58.8739 35.225 57.4208 35.225C55.2287 35.225 53.1243 36.1 51.5836 37.6375C50.0303 39.1875 49.166 41.275 49.166 43.4625V43.7H88.3984V43.7125Z'
				fill='#F2F2F2'
			/>
			<path
				d='M250.075 21.6876C249.938 20.0501 249.186 18.5251 247.971 17.4001C246.756 16.2876 245.165 15.6626 243.524 15.6626C242.472 15.6626 241.432 15.9376 240.505 16.4251C239.917 14.9251 238.889 13.6376 237.562 12.7376C236.234 11.8251 234.655 11.3376 233.04 11.3376C231.85 11.3376 230.685 11.6126 229.607 12.1376C228.743 10.2626 227.403 8.66262 225.712 7.48762C224.021 6.31262 222.054 5.60012 219.987 5.42512C217.933 5.26262 215.866 5.63762 214.012 6.52512C212.158 7.41262 210.567 8.78762 209.402 10.4876C207.498 9.38762 205.344 8.80012 203.139 8.78762C200.935 8.78762 198.78 9.35012 196.864 10.4501C194.96 11.5501 193.369 13.1251 192.266 15.0251C191.164 16.9251 190.588 19.0876 190.588 21.2751V21.6501L250.063 21.6876H250.075Z'
				fill='#F2F2F2'
			/>
			<path
				d='M296.874 69.7125C296.786 68.7755 296.36 67.9005 295.659 67.2755C294.957 66.6505 294.055 66.2875 293.116 66.2875C292.515 66.2875 291.913 66.4375 291.387 66.7255C291.162 66.1375 290.811 65.6127 290.373 65.1627C289.934 64.7127 289.396 64.3627 288.819 64.1377C288.231 63.9127 287.604 63.8002 286.978 63.8252C286.352 63.8502 285.725 64.0002 285.162 64.2752C284.661 63.2127 283.897 62.3127 282.932 61.6377C281.968 60.9752 280.84 60.5752 279.675 60.4752C278.51 60.3877 277.333 60.6002 276.281 61.1002C275.228 61.6002 274.314 62.3877 273.663 63.3502C272.573 62.7002 271.333 62.3502 270.068 62.3377C268.802 62.3252 267.55 62.6502 266.447 63.2752C265.345 63.9002 264.431 64.8127 263.804 65.9127C263.166 67.0125 262.84 68.2505 262.852 69.5125V69.7125H296.874Z'
				fill='#F2F2F2'
			/>
			<path
				d='M77.7754 75.6627C77.362 75.6627 76.9612 75.7377 76.5729 75.8747C76.5102 74.9497 76.147 74.0747 75.5332 73.3747C74.9194 72.6747 74.1052 72.1997 73.1908 72.0127C72.2889 71.8247 71.3369 71.9377 70.4976 72.3247C69.6583 72.7127 68.9694 73.3747 68.5435 74.1997C68.0049 73.9747 67.4287 73.8627 66.8524 73.8627C65.7126 73.8627 64.6228 74.3127 63.8211 75.1247C63.0194 75.9247 62.5684 77.0127 62.5684 78.1497H81.2327C80.9947 77.4247 80.5187 76.7997 79.9049 76.3497C79.2786 75.8997 78.5395 75.6627 77.7754 75.6627Z'
				fill='#F2F2F2'
			/>
			<path d='M190.601 102.712L182.547 102.837L190.401 102.712H190.601Z' fill='#FFC910' />
			<path
				d='M250.703 152.938H270.783C270.783 152.938 297.664 153.125 305.48 146.587L309.414 129.538L262.941 108.812L239.93 133.488L250.703 152.938Z'
				fill='#003D3D'
			/>
			<path
				d='M71.4882 150.324H114.053L118.763 152.937H126.228L150.016 125.387L97.0168 107.274L59.25 128.637L71.4882 150.324Z'
				fill='#003D3D'
			/>
			<path
				d='M304.276 108.549H309.524C312.305 108.549 314.572 110.799 314.572 113.587C314.572 116.362 312.317 118.624 309.524 118.624H304.276C303.086 118.624 302.121 117.662 302.121 116.474V110.699C302.121 109.512 303.086 108.549 304.276 108.549Z'
				fill='#F3C000'
			/>
			<path
				d='M313.145 126.551C313.145 130.151 312.632 133.287 311.755 136.025C310.778 139.15 309.362 141.737 307.771 143.887C307.02 144.887 306.243 145.787 305.467 146.587C304.627 130.099 289.283 117.437 271.884 121.074C260.209 123.512 251.854 133.05 250.464 144.6C250.313 145.763 250.251 146.962 250.251 148.174C250.263 149.812 250.413 151.399 250.702 152.949H126.228C126.24 152.887 126.253 152.801 126.265 152.738C126.754 149.988 126.804 147.238 126.466 144.613C124.85 131.913 114.277 121.363 100.799 120.525C84.728 119.538 71.3875 132.238 71.3875 148.051C71.3875 148.825 71.4126 149.6 71.4877 150.363H53.7254C49.8172 150.363 46.3223 148.362 44.3056 145.324C43.2283 143.699 42.5645 141.75 42.4768 139.663C42.4267 138.413 42.4267 137.199 42.4642 136.049C43.053 115.012 55.9927 106.451 55.9927 106.451C61.9802 91.2495 71.9888 89.6125 71.9888 89.6125C102.164 49.6875 110.382 47.5625 160.738 47.5625C211.093 47.5625 229.758 50.1 247.695 83.9375C247.695 83.9375 248.923 83.9505 251.002 84.0375C263.24 84.4875 305.366 87.3375 305.366 104.663C305.366 104.663 305.429 104.674 305.567 104.712C306.794 105.087 313.145 107.987 313.145 126.574V126.551Z'
				fill='url(#paint3_linear_1600_1387)'
			/>
			<path
				d='M137.752 59.9874C126.891 60.1749 104.607 63.2249 95.0745 84.0375C93.4335 87.6375 96.0265 91.7375 99.9848 91.7375H138.516C141.51 91.7375 143.927 89.3245 143.927 86.3375V66.0495C143.927 62.6624 141.146 59.9249 137.752 59.9874Z'
				fill='#CCECEA'
			/>
			<path
				d='M305.567 104.688L305.366 104.938H256.138C256.138 104.938 250.539 101.188 253.357 94.5877C256.238 87.8507 251.34 84.2627 250.99 84.0127C263.228 84.4627 305.354 87.3127 305.354 104.638C305.354 104.638 305.417 104.651 305.554 104.688H305.567Z'
				fill='#1AABA1'
			/>
			<path
				d='M60.0375 140.662C60.0375 141.937 59.524 143.087 58.6722 143.937C57.8204 144.787 56.6554 145.299 55.3777 145.299H44.292C43.2147 143.674 42.5508 141.724 42.4631 139.637C42.413 138.387 42.413 137.174 42.4506 136.024H55.3777C57.9456 136.024 60.025 138.099 60.025 140.662H60.0375Z'
				fill='#99DAD5'
			/>
			<path
				d='M311.755 136.024C310.778 139.149 309.362 141.737 307.771 143.887C306.957 143.049 306.469 141.924 306.469 140.674C306.469 138.112 308.548 136.037 311.116 136.037H311.755V136.024Z'
				fill='#99DAD5'
			/>
			<path
				d='M172.487 100.876L161.176 101.838C159.573 101.976 158.195 100.713 158.195 99.1126C158.195 97.5126 159.573 96.2506 161.176 96.3876L172.487 97.3506C173.402 97.4256 174.116 98.2006 174.116 99.1126C174.116 100.038 173.414 100.801 172.487 100.876Z'
				fill='#1AABA1'
			/>
			<path
				d='M56.969 113.351C58.9106 113.351 57.8834 114.888 55.4283 123.388C53.1234 131.338 53.1735 131.976 50.1797 131.976C46.4469 131.976 45.2694 129.851 47.712 122.663C50.1797 115.426 52.5723 113.351 56.9815 113.351H56.969Z'
				fill='#F3C000'
			/>
			<path
				d='M299.993 112.799C301.169 112.799 302.122 111.848 302.122 110.674C302.122 109.501 301.169 108.549 299.993 108.549C298.817 108.549 297.863 109.501 297.863 110.674C297.863 111.848 298.817 112.799 299.993 112.799Z'
				fill='#F3C000'
			/>
			<path
				d='M236.973 76.4124C236.973 75.3004 236.07 74.3994 234.956 74.3994C233.842 74.3994 232.939 75.3004 232.939 76.4124V85.6994C232.939 86.8114 233.842 87.7124 234.956 87.7124C236.07 87.7124 236.973 86.8114 236.973 85.6994V76.4124Z'
				fill='#80D1CB'
			/>
			<path
				d='M250.703 152.938H126.229C126.241 152.876 126.254 152.788 126.266 152.726C126.755 149.976 126.805 147.226 126.467 144.601H250.465C250.314 145.763 250.252 146.963 250.252 148.176C250.264 149.813 250.414 151.401 250.703 152.951V152.938Z'
				fill='#008278'
			/>
			<path
				d='M99.034 171.587C112.075 171.587 122.646 161.038 122.646 148.024C122.646 135.011 112.075 124.462 99.034 124.462C85.9934 124.462 75.4219 135.011 75.4219 148.024C75.4219 161.038 85.9934 171.587 99.034 171.587Z'
				fill='#005351'
			/>
			<path
				d='M113.036 148.012C113.036 155.737 106.761 161.987 99.0446 161.987C91.3284 161.987 85.0527 155.724 85.0527 148.012C85.0527 140.299 91.3033 134.049 99.0446 134.049C106.786 134.049 113.036 140.312 113.036 148.012Z'
				fill='#CCECEA'
			/>
			<path
				d='M113.037 148.012H85.041C85.041 140.299 91.2916 134.049 99.0329 134.049C106.774 134.049 113.025 140.312 113.025 148.012H113.037Z'
				fill='#E6F6F5'
			/>
			<path
				d='M277.884 171.576C290.924 171.576 301.496 161.026 301.496 148.013C301.496 135 290.924 124.451 277.884 124.451C264.843 124.451 254.271 135 254.271 148.013C254.271 161.026 264.843 171.576 277.884 171.576Z'
				fill='#005351'
			/>
			<path
				d='M277.884 161.988C285.618 161.988 291.888 155.731 291.888 148.013C291.888 140.295 285.618 134.038 277.884 134.038C270.149 134.038 263.879 140.295 263.879 148.013C263.879 155.731 270.149 161.988 277.884 161.988Z'
				fill='#CCECEA'
			/>
			<path
				d='M291.876 148.012H263.879C263.879 140.3 270.13 134.05 277.871 134.05C285.613 134.05 291.863 140.312 291.863 148.012H291.876Z'
				fill='#E6F6F5'
			/>
			<path
				d='M224.96 91.7245H161.364C158.37 91.7245 155.953 89.3125 155.953 86.3375V66.0495C155.953 62.6623 158.733 59.9873 162.128 59.9873C179.753 59.9873 193.857 60.7373 204.818 63.8123C216.718 67.1375 224.91 73.2125 229.87 84.0495C231.511 87.6375 228.918 91.7375 224.96 91.7375V91.7245Z'
				fill='#CCECEA'
			/>
			<path
				d='M224.96 91.7245H204.818V63.7998C216.718 67.1245 224.91 73.1995 229.871 84.0375C231.511 87.6245 228.919 91.7245 224.96 91.7245Z'
				fill='#E6F6F5'
			/>
			<path
				d='M167.539 50.475C169.192 50.3125 170.445 48.8875 170.307 47.3C170.182 45.7125 168.729 44.55 167.075 44.725C165.422 44.8875 164.169 46.3125 164.307 47.9C164.432 49.4875 165.885 50.65 167.539 50.475Z'
				fill='#FFBA97'
			/>
			<path
				d='M181.793 46.3126C182.344 46.5251 184.599 48.1001 185.113 48.7876C185.626 49.4751 185.113 49.9876 183.459 49.5126C183.459 49.5126 183.847 50.3876 182.783 50.2001C181.718 50.0126 180.591 49.4001 179.789 49.3626C178.987 49.3251 173.814 47.9751 173.701 47.4376C173.588 46.9001 178.411 44.9626 181.793 46.3126Z'
				fill='#EDC297'
			/>
			<path
				d='M182.996 44.5377C182.006 44.3252 180.703 44.4252 178.261 44.3502C175.818 44.2752 173.626 44.0627 172.311 44.2877C170.996 44.5002 167.388 44.1002 165.747 44.0752C165.747 44.0752 165.534 45.1627 165.659 46.2752C164.432 46.9877 163.605 48.2877 164.382 48.9502C165.321 49.7377 169.292 50.2877 171.835 49.8377C174.378 49.3877 175.63 49.6752 176.545 49.7877C177.459 49.9002 177.822 49.7877 179.025 49.7877C180.227 49.7877 180.014 48.6252 179.025 48.1502C178.123 47.7127 176.971 47.4127 175.968 47.2252C176.106 47.1752 176.219 47.1252 176.282 47.1002C177.008 46.7377 180.365 46.1502 182.006 46.3752C183.647 46.5877 185.539 47.1377 185.689 46.3752C185.839 45.6127 183.973 44.7752 182.996 44.5502V44.5377Z'
				fill='#F2CBA5'
			/>
			<path
				d='M116.908 33.9375L119.188 48.45C119.188 48.45 120.19 50.025 121.931 50.5C127.668 52.075 142.913 53.9125 169.281 51.05V44.05C169.281 44.05 139.142 41.5 130.85 38.8C122.557 36.1 116.896 33.9375 116.896 33.9375H116.908Z'
				fill='#F3C000'
			/>
			<path
				d='M127.016 87.5255C126.126 89.2625 107.587 91.2005 107.587 91.2005L102.201 31.8252C102.201 31.8252 106.661 32.9252 113.312 33.4002C114.74 33.5002 115.529 33.6127 116.907 33.9502L120.364 38.3377L124.987 74.1125C125.563 80.0875 127.918 85.8005 127.028 87.5375L127.016 87.5255Z'
				fill='#F3C000'
			/>
			<path
				d='M85.0039 166.825L93.8851 167.937L92.4446 163.212L91.9184 161.487H85.1417L85.0039 166.825Z'
				fill='#F2CBA5'
			/>
			<path
				d='M86.0063 164.925C88.4866 165 90.0899 167.65 91.6307 167.325C93.8603 166.862 92.5701 163.612 92.5701 163.612C92.5701 163.612 94.399 164.312 94.6746 167.225L95.2257 172.937C94.5743 173.362 91.7183 173.625 89.4887 175.062C87.1462 176.562 79.5553 177.812 75.6847 175.8C75.6847 175.8 75.5469 173.325 78.3027 172.312C83.0877 170.55 83.1629 164.85 86.0063 164.925Z'
				fill='#333333'
			/>
			<path
				d='M100.436 160.076V170.163L108.24 166.938L108.202 163.651L108.19 163.026L108.165 161.476L100.436 160.076Z'
				fill='#F2CBA5'
			/>
			<path
				d='M109.854 163.924C106.072 163.424 106.973 167.55 104.694 167.438C101.274 167.263 100.447 163.438 100.447 163.438C97.6164 166.726 98.5558 173.012 98.5558 173.012C98.5558 173.012 105.746 173.3 109.441 173.725C113.136 174.15 121.228 173.912 122.606 173.199C122.606 173.199 121.917 169.938 118.097 169.188C110.606 167.712 109.854 163.938 109.854 163.938V163.924Z'
				fill='#333333'
			/>
			<path
				d='M88.3991 36.675C88.4366 37.7125 89.1882 40.4 95.8773 40.85C104.22 41.425 102.616 36.25 102.616 36.25L102.078 30.5625C102.078 30.5625 88.8124 25.6499 88.6621 28.5624C88.612 29.5249 88.5744 30.6875 88.5369 31.8125C88.4617 34.1 88.4241 36.25 88.4241 36.25C88.4241 36.25 88.3865 36.4125 88.3991 36.6625V36.675Z'
				fill='#F2CBA5'
			/>
			<path
				d='M91.8172 102.901C91.93 103.126 92.5187 104.563 93.3454 106.601C93.5584 107.126 93.7964 107.701 94.0344 108.313C96.5522 114.538 100.298 123.938 100.436 124.351C100.636 124.951 99.8215 160.951 99.8215 160.951C104.933 162.876 109.881 161.651 109.881 161.651C109.881 161.651 113.488 133.588 114.703 126.288C115.918 118.988 109.355 90.9006 109.254 89.7006C109.154 88.5006 109.78 86.0006 108.24 85.4006C101.626 82.8256 97.5793 84.1006 95.1242 86.8756C94.1722 87.9506 93.4707 89.2376 92.9446 90.6126C90.9404 95.8756 91.5792 102.438 91.8047 102.901H91.8172Z'
				fill='url(#paint4_linear_1600_1387)'
			/>
			<path
				d='M77.587 124.988C77.9126 126.626 83.7624 162.188 83.7624 162.188C89.2239 162.951 93.3701 161.251 93.3701 161.251C93.3701 161.251 93.2449 155.551 93.0945 148.826C93.0945 148.826 93.0945 148.801 93.0945 148.788C92.8816 139.576 92.6311 128.463 92.5559 127.613C92.4682 126.576 93.3701 115.526 94.034 108.301C94.3096 105.288 94.5476 102.938 94.6603 102.251L98.5685 90.5377L99.5581 87.5877C99.5581 87.5877 97.7669 87.3007 95.1238 86.8877C91.1655 86.2757 85.3032 85.3757 80.7185 84.7757C76.7853 84.2627 73.779 83.9507 73.7414 84.2007C73.6161 84.9627 77.2487 123.376 77.5744 125.013L77.587 124.988Z'
				fill='url(#paint5_linear_1600_1387)'
			/>
			<path
				d='M94.2229 26.3126C94.2229 26.3126 88.9618 29.0876 86.1935 25.7501C84.3271 23.5126 83.8511 18.2001 84.7655 15.0126C86.1559 10.1501 88.9743 7.9751 96.177 7.9751C103.091 7.9751 102.954 11.3376 104.394 16.7001C105.584 21.1376 105.259 24.8376 102.215 26.6501C99.3837 28.3376 97.2166 31.2751 97.2166 31.2751L94.2354 26.3251L94.2229 26.3126Z'
				fill='#7C7C7C'
			/>
			<path
				d='M100.786 31.2002C100.799 31.3127 100.198 36.2127 96.4773 36.3752C92.0305 36.5752 89.8008 31.7877 89.8384 28.8752C89.8759 25.9627 100.786 31.2002 100.786 31.2002Z'
				fill='#EDC297'
			/>
			<path
				d='M99.2451 13.05C100.085 13.4 101.826 14.2375 102.665 16.3375C102.928 16.9875 103.091 17.75 103.116 18.6625C103.229 22.5125 103.517 27.95 102.089 30.5625C100.661 33.175 96.4267 36.6375 91.0529 31.625C85.6791 26.625 86.5309 18.125 86.8817 15.775C87.2324 13.425 93.3828 10.5875 99.2451 13.0375V13.05Z'
				fill='#F2CBA5'
			/>
			<path
				d='M86.0063 11.9126C88.8247 7.67511 92.7078 7.90011 95.426 7.82511C101.013 7.66261 102.453 7.46261 103.744 9.51261C105.034 11.5626 104.908 16.0626 98.044 16.6126C92.3571 17.0626 89.2881 15.7376 89.2881 15.7376C89.2881 15.7376 89.1504 19.3376 86.9207 20.6376C84.691 21.9501 83.6137 16.2126 86.0063 11.9126Z'
				fill='#7C7C7C'
			/>
			<path
				d='M88.5352 35.6126C89.5624 37.9001 93.1449 40.3626 97.4289 39.4251C102.164 38.3876 102.214 34.1876 102.251 32.8501C102.251 32.8501 103.278 34.8376 103.541 37.3751L111.107 47.4876C111.107 47.4876 111.107 49.6251 111.107 52.9126C111.057 63.7251 111.107 87.9005 111.107 87.9005C111.107 87.9005 99.3204 90.1375 85.6667 87.5505C80.3806 86.5505 76.4473 85.5755 76.4473 85.5755L88.5227 35.5876L88.5352 35.6126Z'
				fill='#005A55'
			/>
			<path
				d='M67.7168 91.1505C67.7168 91.1505 71.4121 59.9002 74.2681 44.5127C75.1074 39.9752 75.8715 36.8252 76.4602 36.2502C76.8861 35.8252 77.4373 35.4502 78.0636 35.1252C80.3809 33.9002 83.7129 33.2877 85.2913 33.0502C85.8424 32.9752 86.1681 32.9252 86.1681 32.9252C86.9948 32.5877 87.9218 31.8252 88.5481 31.8252L90.9782 41.2252C90.0763 61.4252 76.4602 96.9505 76.4602 96.9505L67.7168 91.1505Z'
				fill='url(#paint6_linear_1600_1387)'
			/>
			<path
				d='M79.4545 98.6997C78.7405 98.1247 77.8887 96.4247 76.8365 95.7247C75.7843 95.0247 74.6319 93.8747 74.3438 92.7247C74.2686 92.4377 74.4189 91.4377 73.7425 91.2247C71.7258 90.5877 67.2914 91.1997 67.2539 92.7747C67.2539 93.1247 67.5294 93.5247 67.8802 94.1247C67.9052 94.1997 68.0806 94.7497 68.2685 95.6377C68.6067 97.2247 68.9825 99.9247 68.6819 103.088C68.519 104.788 69.2581 105.325 69.2581 105.325C69.1954 108.95 70.185 109.113 70.4105 109.1C70.4105 109.188 70.398 109.263 70.398 109.325C70.2852 110.65 71.826 111.488 72.2143 109.738C72.6026 107.988 73.1412 103.95 73.1788 103.313C73.2164 102.688 73.5797 102.925 73.73 103.65C73.7801 103.913 74.5943 108.063 74.7195 108.875C74.8448 109.675 76.5108 110.15 76.4357 108.025C76.373 105.9 75.3459 100.975 75.5964 100.113C75.8469 99.2497 76.0724 98.2877 76.0724 98.2877C76.0724 98.2877 78.3021 100.275 79.5297 100.238C80.7572 100.213 80.1935 99.2747 79.4545 98.6877V98.6997Z'
				fill='#F2CBA5'
			/>
			<path
				d='M102.001 20.8127C102.088 20.5127 102.715 19.3502 103.516 20.0002C104.318 20.6502 103.892 23.9752 102.001 24.7377C100.109 25.5002 102.001 20.8127 102.001 20.8127Z'
				fill='#F2CBA5'
			/>
			<path
				d='M87.584 20.8127C87.4963 20.5127 86.87 19.3502 86.0683 20.0002C85.2667 20.6502 85.6925 23.9752 87.584 24.7377C89.4755 25.5002 87.584 20.8127 87.584 20.8127Z'
				fill='#F2CBA5'
			/>
			<path
				d='M66.3524 94.1745C66.4902 94.4495 68.8577 94.0125 70.9997 93.4495C72.8536 92.9745 74.5571 92.4125 74.507 92.1745C74.3943 91.6625 75.5592 67.1125 75.8849 66.0125C76.2106 64.9249 80.3318 56.0874 80.2441 55.5374C80.1689 55.1124 84.1773 41.8874 81.8224 36.8999C81.1585 35.4874 79.981 34.7249 78.0645 35.0999C74.8202 35.7374 70.8493 44.6249 68.319 54.0374C68.2188 54.3874 68.1311 54.7374 68.0434 55.0874C68.0434 55.1249 68.0309 55.1624 68.0184 55.1999C67.0038 59.1749 66.2647 63.1749 65.9516 66.6625C64.8618 78.7745 65.8639 93.1495 66.3649 94.1625L66.3524 94.1745Z'
				fill='#F3C000'
			/>
			<defs>
				<radialGradient
					id='paint0_radial_1600_1387'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(172.865 147.113) scale(155.928 136.49)'
				>
					<stop offset='0.14' stopOpacity='0.05' />
					<stop offset='1' stopOpacity='0' />
				</radialGradient>
				<radialGradient
					id='paint1_radial_1600_1387'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(238.496 152.324) scale(67.0258 136.49)'
				>
					<stop stopColor='white' />
					<stop offset='0.17' stopColor='white' stopOpacity='0.85' />
					<stop offset='0.55' stopColor='white' stopOpacity='0.48' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</radialGradient>
				<radialGradient
					id='paint2_radial_1600_1387'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(113.552 129379) scale(67.0258 136.49)'
				>
					<stop stopColor='white' />
					<stop offset='0.17' stopColor='white' stopOpacity='0.85' />
					<stop offset='0.55' stopColor='white' stopOpacity='0.48' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</radialGradient>
				<linearGradient
					id='paint3_linear_1600_1387'
					x1='177.798'
					y1='156.812'
					x2='177.798'
					y2='43.1625'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#008A80' />
					<stop offset='1' stopColor='#1AABA1' />
				</linearGradient>
				<linearGradient
					id='paint4_linear_1600_1387'
					x1='100.924'
					y1='83.6006'
					x2='111.627'
					y2='216.092'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#E6D1D1' />
					<stop offset='1' stopColor='#D2B7B2' />
				</linearGradient>
				<linearGradient
					id='paint5_linear_1600_1387'
					x1='92.0298'
					y1='123.238'
					x2='73.566'
					y2='123.238'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.15' stopColor='#E6D1D1' />
					<stop offset='1' stopColor='#D2B7B2' />
				</linearGradient>
				<linearGradient
					id='paint6_linear_1600_1387'
					x1='82.4728'
					y1='36.2127'
					x2='76.5226'
					y2='94.5775'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#F3C000' />
					<stop offset='1' stopColor='#DBAD00' />
				</linearGradient>
			</defs>
		</svg>
	) : (
		<svg {...props} width='357' height='183' viewBox='0 0 357 183' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M49.4531 170.675C49.4531 176.363 109.053 182.963 177.747 182.963C246.442 182.963 302.121 178.351 302.121 172.663C302.121 166.976 246.429 162.376 177.747 162.376C109.066 162.376 49.4531 164.988 49.4531 170.663V170.675Z'
				fill='#1A1A1A'
			/>
			<path
				d='M308.386 3.93807C307.823 3.73807 307.234 3.62608 306.645 3.63808C307.384 4.28808 307.91 5.16306 308.148 6.11306C308.386 7.07606 308.324 8.07606 307.973 9.00106C307.622 9.92606 306.996 10.7261 306.194 11.2761C305.38 11.8381 304.415 12.1381 303.426 12.1511C303.964 12.6761 304.603 13.0631 305.305 13.3011C306.006 13.5381 306.758 13.6131 307.497 13.5131C308.236 13.4131 308.95 13.1631 309.564 12.7511C310.19 12.3381 310.716 11.8011 311.092 11.1631C311.48 10.5261 311.706 9.81307 311.781 9.06307C311.843 8.32607 311.743 7.57606 311.48 6.87606C311.217 6.17606 310.791 5.55108 310.253 5.03808C309.714 4.52608 309.063 4.15108 308.349 3.92608H308.386V3.93807Z'
				fill='#4D4D4D'
			/>
			<path
				d='M280.426 4.88809C280.802 4.88809 281.103 4.58807 281.103 4.21307C281.103 3.83807 280.802 3.53809 280.426 3.53809C280.051 3.53809 279.75 3.83807 279.75 4.21307C279.75 4.58807 280.051 4.88809 280.426 4.88809Z'
				fill='#4D4D4D'
			/>
			<path
				d='M84.7916 1.34998C85.1674 1.34998 85.468 1.05099 85.468 0.675995C85.468 0.300995 85.1674 0 84.7916 0C84.4158 0 84.1152 0.300995 84.1152 0.675995C84.1152 1.05099 84.4158 1.34998 84.7916 1.34998Z'
				fill='#4D4D4D'
			/>
			<path
				d='M88.8112 38.3261C89.187 38.3261 89.4876 38.0261 89.4876 37.6511C89.4876 37.2761 89.187 36.9761 88.8112 36.9761C88.4354 36.9761 88.1348 37.2761 88.1348 37.6511C88.1348 38.0261 88.4354 38.3261 88.8112 38.3261Z'
				fill='#4D4D4D'
			/>
			<path
				d='M108.791 10.1381C109.167 10.1381 109.468 9.83807 109.468 9.46307C109.468 9.08807 109.167 8.78809 108.791 8.78809C108.415 8.78809 108.115 9.08807 108.115 9.46307C108.115 9.83807 108.415 10.1381 108.791 10.1381Z'
				fill='#999999'
			/>
			<path
				d='M63.3834 29.4262C63.7592 29.4262 64.0598 29.1262 64.0598 28.7512C64.0598 28.3762 63.7592 28.0762 63.3834 28.0762C63.0076 28.0762 62.707 28.3762 62.707 28.7512C62.707 29.1262 63.0076 29.4262 63.3834 29.4262Z'
				fill='#999999'
			/>
			<path
				d='M86.0045 17.351C86.3803 17.351 86.6809 17.051 86.6809 16.676C86.6809 16.301 86.3803 16 86.0045 16C85.6287 16 85.3281 16.301 85.3281 16.676C85.3281 17.051 85.6287 17.351 86.0045 17.351Z'
				fill='#4D4D4D'
			/>
			<path
				d='M183.697 28.163C184.073 28.163 184.374 27.863 184.374 27.488C184.374 27.113 184.073 26.813 183.697 26.813C183.322 26.813 183.021 27.113 183.021 27.488C183.021 27.863 183.322 28.163 183.697 28.163Z'
				fill='#4D4D4D'
			/>
			<path
				d='M301.609 31.9262C301.984 31.9262 302.285 31.6262 302.285 31.2512C302.285 30.8762 301.984 30.5762 301.609 30.5762C301.233 30.5762 300.932 30.8762 300.932 31.2512C300.932 31.6262 301.233 31.9262 301.609 31.9262Z'
				fill='#999999'
			/>
			<path
				d='M288.857 46.5512C289.232 46.5512 289.533 46.2512 289.533 45.8762C289.533 45.5012 289.232 45.2012 288.857 45.2012C288.481 45.2012 288.18 45.5012 288.18 45.8762C288.18 46.2512 288.481 46.5512 288.857 46.5512Z'
				fill='#4D4D4D'
			/>
			<path
				d='M221.965 12.9511C222.341 12.9511 222.642 12.6511 222.642 12.2761C222.642 11.9011 222.341 11.6011 221.965 11.6011C221.59 11.6011 221.289 11.9011 221.289 12.2761C221.289 12.6511 221.59 12.9511 221.965 12.9511Z'
				fill='#4D4D4D'
			/>
			<path
				d='M287.629 17.351C288.005 17.351 288.305 17.051 288.305 16.676C288.305 16.301 288.005 16 287.629 16C287.253 16 286.953 16.301 286.953 16.676C286.953 17.051 287.253 17.351 287.629 17.351Z'
				fill='#999999'
			/>
			<path
				d='M56.9576 6.49991C57.3334 6.49991 57.634 6.19989 57.634 5.82489C57.634 5.44989 57.3334 5.1499 56.9576 5.1499C56.5818 5.1499 56.2812 5.44989 56.2812 5.82489C56.2812 6.19989 56.5818 6.49991 56.9576 6.49991Z'
				fill='#4D4D4D'
			/>
			<path
				d='M236.233 35.7132C236.132 34.6382 235.631 33.6382 234.83 32.9012C234.028 32.1762 232.976 31.7762 231.898 31.7762C231.209 31.7762 230.533 31.9512 229.919 32.2762C229.531 31.2882 228.855 30.4382 227.978 29.8262C227.101 29.2262 226.061 28.9012 224.996 28.8882C224.207 28.8882 223.431 29.0762 222.729 29.4262C222.153 28.1882 221.264 27.1262 220.149 26.3382C219.034 25.5512 217.719 25.0882 216.366 24.9762C215 24.8632 213.635 25.1132 212.407 25.7012C211.18 26.2882 210.115 27.1882 209.351 28.3262C208.086 27.5882 206.658 27.1882 205.192 27.1882C202.988 27.1882 200.883 28.0632 199.33 29.6132C197.777 31.1632 196.9 33.2762 196.9 35.4632V35.7012H236.258L236.233 35.7132Z'
				fill='#292929'
			/>
			<path
				d='M72.69 70.6879C72.6399 70.1749 72.477 69.6749 72.1889 69.2499C71.9008 68.8249 71.525 68.4628 71.0741 68.2128C70.6231 67.9628 70.1095 67.8249 69.596 67.8129C69.0824 67.8129 68.5688 67.9249 68.1053 68.1499C67.9174 67.6499 67.6293 67.2128 67.2535 66.8248C66.8777 66.4498 66.4393 66.1498 65.9383 65.9628C65.4497 65.7628 64.9236 65.6748 64.385 65.6998C63.8589 65.7248 63.3328 65.8498 62.8568 66.0748C62.4434 65.1748 61.7921 64.3998 60.9779 63.8378C60.1636 63.2748 59.2116 62.9378 58.2221 62.8498C57.2325 62.7748 56.2429 62.9499 55.341 63.3879C54.4516 63.8129 53.675 64.4748 53.1239 65.2998C52.2094 64.7628 51.1572 64.4628 50.08 64.4628C49.0152 64.4628 47.963 64.7379 47.0361 65.2749C46.1091 65.8129 45.345 66.5749 44.8189 67.5129C44.2928 68.4379 44.0172 69.4879 44.0297 70.5629V70.7378L72.6774 70.6879H72.69Z'
				fill='#292929'
			/>
			<g opacity='0.2'>
				<path
					opacity='0.2'
					d='M132.378 17.5498C132.265 17.8498 132.128 18.1378 132.002 18.4498C132.115 18.1498 132.24 17.8498 132.378 17.5498Z'
					fill='black'
				/>
				<path
					opacity='0.2'
					d='M202.764 9.61279C203.014 9.47479 203.252 9.3378 203.478 9.1998C203.277 9.3378 203.039 9.47479 202.789 9.61279H202.764ZM204.78 8.1748C204.856 8.0998 204.931 8.0248 204.993 7.9628C205.069 7.8878 204.881 8.1128 204.793 8.1748H204.768H204.78ZM205.369 7.38782C205.407 7.32482 205.432 7.2498 205.457 7.1748C205.432 7.2498 205.407 7.31282 205.382 7.38782H205.369ZM205.494 6.99982C205.494 6.93782 205.494 6.8628 205.494 6.7998C205.507 6.8628 205.519 6.92482 205.519 6.99982H205.494Z'
					fill='black'
				/>
			</g>
			<path
				d='M0 149.951C0 68.5012 79.9179 2.51318 178.5 2.51318C277.082 2.51318 357 68.5382 357 149.988L0 149.963V149.951Z'
				fill='url(#paint0_radial_1600_1388)'
			/>
			<path
				d='M166.199 155.463C166.199 74.0128 200.171 7.98779 242.084 7.98779C283.997 7.98779 317.993 73.9628 317.993 155.463H166.199Z'
				fill='url(#paint1_radial_1600_1388)'
			/>
			<path
				d='M43.1289 155.463C43.1289 74.0128 77.1002 7.98779 119.014 7.98779C160.927 7.98779 194.911 73.9628 194.911 155.463H43.1289Z'
				fill='url(#paint2_radial_1600_1388)'
			/>
			<path d='M38.0552 149.7H18.1133V121.263L28.0843 112.738L38.0552 121.263V149.7Z' fill='#1F1F1F' />
			<path d='M38.0549 121.263H49.4539L39.4829 112.738H28.084L38.0549 121.263Z' fill='#292929' />
			<path d='M35.9121 114.775V109.9H40.1836V118.425L35.9121 114.775Z' fill='#1F1F1F' />
			<path d='M38.043 149.7H49.4419V121.263H38.043V149.7Z' fill='#292929' />
			<path d='M25.4793 128.025H20.832V134.975H25.4793V128.025Z' fill='#1A1A1A' />
			<path d='M45.3836 128.025H40.7363V134.975H45.3836V128.025Z' fill='#1F1F1F' />
			<path d='M33.6707 128.025H29.0234V134.975H33.6707V128.025Z' fill='#1A1A1A' />
			<path d='M25.4793 138.575H20.832V145.1H25.4793V138.575Z' fill='#1A1A1A' />
			<path d='M45.3836 138.575H40.7363V145.1H45.3836V138.575Z' fill='#1F1F1F' />
			<path d='M33.6707 138.575H29.0234V149.738H33.6707V138.575Z' fill='#1A1A1A' />
			<path
				d='M28.1467 122.55C29.2114 122.55 30.0882 121.688 30.0882 120.613C30.0882 119.538 29.2239 118.675 28.1467 118.675C27.0694 118.675 26.2051 119.538 26.2051 120.613C26.2051 121.688 27.0694 122.55 28.1467 122.55Z'
				fill='#1A1A1A'
			/>
			<path d='M327.338 143.013H327.927V149.951H327.338V143.013Z' fill='#1F1F1F' />
			<path
				d='M330.796 112.263C331.886 112.176 332.976 112.263 334.028 112.576L334.066 118.526C333.99 119.263 334.153 120.001 334.529 120.626C335.306 121.688 336.884 121.551 338.162 121.863C338.838 122.013 339.452 122.338 339.953 122.801C340.454 123.263 340.842 123.851 341.043 124.501C341.231 125.163 341.206 125.863 340.943 126.501C340.692 127.138 340.229 127.676 339.627 128.013C338.763 128.438 337.736 128.376 336.809 128.713C334.567 129.463 333.652 132.151 333.514 134.501C333.364 136.851 333.64 139.363 332.537 141.438C331.134 144.038 327.74 145.238 324.921 144.363C323.531 143.876 322.291 143.013 321.351 141.876C320.399 140.738 319.786 139.376 319.548 137.913C319.272 136.276 319.447 134.563 318.946 133.001C318.383 131.213 317.03 129.288 318.007 127.688C318.996 126.101 322.028 126.213 322.792 124.376C323.318 123.101 322.379 121.726 322.09 120.363C321.978 119.501 322.053 118.613 322.341 117.788C322.629 116.963 323.093 116.213 323.719 115.601C326.086 113.388 328.679 112.401 330.784 112.226L330.796 112.263Z'
				fill='#292929'
			/>
			<path
				d='M77.7754 78.1632C77.362 78.1632 76.9612 78.2382 76.5729 78.3752C76.5102 77.4502 76.147 76.5752 75.5332 75.8752C74.9194 75.1752 74.1052 74.7002 73.1908 74.5132C72.2889 74.3252 71.3369 74.4382 70.4976 74.8252C69.6583 75.2132 68.9694 75.8752 68.5435 76.7002C68.0049 76.4752 67.4287 76.3632 66.8524 76.3632C65.7126 76.3632 64.6228 76.8132 63.8211 77.6252C63.0194 78.4252 62.5684 79.5132 62.5684 80.6502H81.2327C80.9947 79.9252 80.5187 79.3002 79.9049 78.8502C79.2786 78.4002 78.5395 78.1632 77.7754 78.1632Z'
				fill='#F2F2F2'
			/>
			<path d='M190.601 105.213L182.547 105.338L190.401 105.213H190.601Z' fill='#FFC910' />
			<path
				d='M250.703 155.438H270.783C270.783 155.438 297.664 155.626 305.48 149.088L309.414 132.038L262.941 111.313L239.93 135.988L250.703 155.438Z'
				fill='#003D3D'
			/>
			<path
				d='M71.4882 152.825H114.053L118.763 155.438H126.228L150.016 127.9L97.0168 109.775L59.25 131.138L71.4882 152.825Z'
				fill='#003D3D'
			/>
			<path
				d='M304.276 111.05H309.524C312.305 111.05 314.572 113.3 314.572 116.088C314.572 118.863 312.317 121.125 309.524 121.125H304.276C303.086 121.125 302.121 120.163 302.121 118.975V113.2C302.121 112.013 303.086 111.05 304.276 111.05Z'
				fill='#F3C000'
			/>
			<path
				d='M313.145 129.051C313.145 132.651 312.632 135.788 311.755 138.526C310.778 141.651 309.362 144.238 307.771 146.388C307.02 147.388 306.243 148.288 305.467 149.088C304.627 132.6 289.283 119.938 271.884 123.575C260.209 126.013 251.854 135.55 250.464 147.1C250.313 148.263 250.251 149.463 250.251 150.675C250.263 152.313 250.413 153.9 250.702 155.45H126.228C126.24 155.388 126.253 155.301 126.265 155.238C126.754 152.488 126.804 149.738 126.466 147.113C124.85 134.413 114.277 123.863 100.799 123.025C84.728 122.038 71.3875 134.738 71.3875 150.551C71.3875 151.325 71.4126 152.1 71.4877 152.863H53.7254C49.8172 152.863 46.3223 150.863 44.3056 147.825C43.2283 146.2 42.5645 144.25 42.4768 142.163C42.4267 140.913 42.4267 139.7 42.4642 138.55C43.053 117.513 55.9927 108.951 55.9927 108.951C61.9802 93.75 71.9888 92.113 71.9888 92.113C102.164 52.188 110.382 50.063 160.738 50.063C211.093 50.063 229.758 52.6 247.695 86.438C247.695 86.438 248.923 86.451 251.002 86.538C263.24 86.988 305.366 89.838 305.366 107.163C305.366 107.163 305.429 107.175 305.567 107.213C306.794 107.588 313.145 110.488 313.145 129.075V129.051Z'
				fill='url(#paint3_linear_1600_1388)'
			/>
			<path
				d='M137.752 62.4879C126.891 62.6749 104.607 65.7249 95.0745 86.5379C93.4335 90.1379 96.0265 94.2379 99.9848 94.2379H138.516C141.51 94.2379 143.927 91.8249 143.927 88.8379V68.5499C143.927 65.1629 141.146 62.4249 137.752 62.4879Z'
				fill='#CCECEA'
			/>
			<path
				d='M305.567 107.188L305.366 107.438H256.138C256.138 107.438 250.539 103.688 253.357 97.0882C256.238 90.3512 251.34 86.7632 250.99 86.5132C263.228 86.9632 305.354 89.8132 305.354 107.138C305.354 107.138 305.417 107.151 305.554 107.188H305.567Z'
				fill='#1AABA1'
			/>
			<path
				d='M60.0375 143.163C60.0375 144.438 59.524 145.588 58.6722 146.438C57.8204 147.288 56.6554 147.8 55.3777 147.8H44.292C43.2147 146.175 42.5508 144.225 42.4631 142.138C42.413 140.888 42.413 139.675 42.4506 138.525H55.3777C57.9456 138.525 60.025 140.6 60.025 143.163H60.0375Z'
				fill='#99DAD5'
			/>
			<path
				d='M311.755 138.525C310.778 141.65 309.362 144.238 307.771 146.388C306.957 145.55 306.469 144.425 306.469 143.175C306.469 140.613 308.548 138.538 311.116 138.538H311.755V138.525Z'
				fill='#99DAD5'
			/>
			<path
				d='M172.487 103.376L161.176 104.338C159.573 104.476 158.195 103.213 158.195 101.613C158.195 100.013 159.573 98.7511 161.176 98.8881L172.487 99.8511C173.402 99.9261 174.116 100.701 174.116 101.613C174.116 102.538 173.414 103.301 172.487 103.376Z'
				fill='#1AABA1'
			/>
			<path
				d='M56.969 115.851C58.9106 115.851 57.8834 117.388 55.4283 125.888C53.1234 133.838 53.1735 134.476 50.1797 134.476C46.4469 134.476 45.2694 132.351 47.712 125.163C50.1797 117.926 52.5723 115.851 56.9815 115.851H56.969Z'
				fill='#F3C000'
			/>
			<path
				d='M299.993 115.3C301.169 115.3 302.122 114.349 302.122 113.175C302.122 112.002 301.169 111.05 299.993 111.05C298.817 111.05 297.863 112.002 297.863 113.175C297.863 114.349 298.817 115.3 299.993 115.3Z'
				fill='#F3C000'
			/>
			<path
				d='M236.973 78.9129C236.973 77.8009 236.07 76.8999 234.956 76.8999C233.842 76.8999 232.939 77.8009 232.939 78.9129V88.1999C232.939 89.3119 233.842 90.2129 234.956 90.2129C236.07 90.2129 236.973 89.3119 236.973 88.1999V78.9129Z'
				fill='#80D1CB'
			/>
			<path
				d='M250.703 155.438H126.229C126.241 155.376 126.254 155.288 126.266 155.226C126.755 152.476 126.805 149.726 126.467 147.101H250.465C250.314 148.263 250.252 149.463 250.252 150.676C250.264 152.313 250.414 153.901 250.703 155.451V155.438Z'
				fill='#008278'
			/>
			<path
				d='M99.034 174.088C112.075 174.088 122.646 163.539 122.646 150.525C122.646 137.512 112.075 126.963 99.034 126.963C85.9934 126.963 75.4219 137.512 75.4219 150.525C75.4219 163.539 85.9934 174.088 99.034 174.088Z'
				fill='#005351'
			/>
			<path
				d='M113.036 150.513C113.036 158.238 106.761 164.488 99.0446 164.488C91.3284 164.488 85.0527 158.225 85.0527 150.513C85.0527 142.8 91.3033 136.55 99.0446 136.55C106.786 136.55 113.036 142.813 113.036 150.513Z'
				fill='#CCECEA'
			/>
			<path
				d='M113.037 150.513H85.041C85.041 142.8 91.2916 136.55 99.0329 136.55C106.774 136.55 113.025 142.813 113.025 150.513H113.037Z'
				fill='#E6F6F5'
			/>
			<path
				d='M277.884 174.088C290.924 174.088 301.496 163.539 301.496 150.525C301.496 137.512 290.924 126.963 277.884 126.963C264.843 126.963 254.271 137.512 254.271 150.525C254.271 163.539 264.843 174.088 277.884 174.088Z'
				fill='#005351'
			/>
			<path
				d='M277.884 164.5C285.618 164.5 291.888 158.243 291.888 150.525C291.888 142.807 285.618 136.55 277.884 136.55C270.149 136.55 263.879 142.807 263.879 150.525C263.879 158.243 270.149 164.5 277.884 164.5Z'
				fill='#CCECEA'
			/>
			<path
				d='M291.876 150.513H263.879C263.879 142.8 270.13 136.55 277.871 136.55C285.613 136.55 291.863 142.813 291.863 150.513H291.876Z'
				fill='#E6F6F5'
			/>
			<path
				d='M224.96 94.2248H161.364C158.37 94.2248 155.953 91.8128 155.953 88.8378V68.5498C155.953 65.1628 158.733 62.4878 162.128 62.4878C179.753 62.4878 193.857 63.2378 204.818 66.3128C216.718 69.6378 224.91 75.7128 229.87 86.5498C231.511 90.1378 228.918 94.2378 224.96 94.2378V94.2248Z'
				fill='#CCECEA'
			/>
			<path
				d='M224.96 94.2248H204.818V66.2998C216.718 69.6248 224.91 75.6998 229.871 86.5378C231.511 90.1248 228.919 94.2248 224.96 94.2248Z'
				fill='#E6F6F5'
			/>
			<path
				d='M167.539 52.975C169.192 52.813 170.445 51.388 170.307 49.8C170.182 48.213 168.729 47.05 167.075 47.225C165.422 47.388 164.169 48.813 164.307 50.4C164.432 51.988 165.885 53.15 167.539 52.975Z'
				fill='#FFBA97'
			/>
			<path
				d='M181.793 48.813C182.344 49.026 184.599 50.601 185.113 51.288C185.626 51.976 185.113 52.488 183.459 52.013C183.459 52.013 183.847 52.888 182.783 52.701C181.718 52.513 180.591 51.901 179.789 51.863C178.987 51.826 173.814 50.476 173.701 49.938C173.588 49.401 178.411 47.463 181.793 48.813Z'
				fill='#EDC297'
			/>
			<path
				d='M182.996 47.0382C182.006 46.8262 180.703 46.9262 178.261 46.8512C175.818 46.7762 173.626 46.5632 172.311 46.7882C170.996 47.0012 167.388 46.6012 165.747 46.5762C165.747 46.5762 165.534 47.6632 165.659 48.7762C164.432 49.4882 163.605 50.7882 164.382 51.4512C165.321 52.2382 169.292 52.7882 171.835 52.3382C174.378 51.8882 175.63 52.1762 176.545 52.2882C177.459 52.4012 177.822 52.2882 179.025 52.2882C180.227 52.2882 180.014 51.1262 179.025 50.6512C178.123 50.2132 176.971 49.9132 175.968 49.7262C176.106 49.6762 176.219 49.6262 176.282 49.6012C177.008 49.2382 180.365 48.6512 182.006 48.8762C183.647 49.0882 185.539 49.6382 185.689 48.8762C185.839 48.1132 183.973 47.2762 182.996 47.0512V47.0382Z'
				fill='#F2CBA5'
			/>
			<path
				d='M116.908 36.4512L119.188 50.9632C119.188 50.9632 120.19 52.5382 121.931 53.0132C127.668 54.5882 142.913 56.4262 169.281 53.5632V46.5632C169.281 46.5632 139.142 44.0132 130.85 41.3132C122.557 38.6132 116.896 36.4512 116.896 36.4512H116.908Z'
				fill='#F3C000'
			/>
			<path
				d='M127.016 90.0262C126.126 91.7632 107.587 93.7012 107.587 93.7012L102.201 34.3262C102.201 34.3262 106.661 35.4262 113.312 35.9012C114.74 36.0012 115.529 36.1132 116.907 36.4512L120.364 40.8382L124.987 76.6132C125.563 82.5882 127.918 88.3012 127.028 90.0382L127.016 90.0262Z'
				fill='#F3C000'
			/>
			<path
				d='M85.0039 169.326L93.8851 170.451L92.4446 165.713L91.9184 163.988H85.1417L85.0039 169.326Z'
				fill='#F2CBA5'
			/>
			<path
				d='M86.0063 167.438C88.4866 167.513 90.0899 170.163 91.6307 169.838C93.8603 169.376 92.5701 166.126 92.5701 166.126C92.5701 166.126 94.399 166.825 94.6746 169.738L95.2257 175.451C94.5743 175.876 91.7183 176.138 89.4887 177.576C87.1462 179.076 79.5553 180.325 75.6847 178.313C75.6847 178.313 75.5469 175.838 78.3027 174.826C83.0877 173.063 83.1629 167.363 86.0063 167.438Z'
				fill='#333333'
			/>
			<path
				d='M100.436 162.576V172.676L108.24 169.438L108.202 166.151L108.19 165.538L108.165 163.988L100.436 162.576Z'
				fill='#F2CBA5'
			/>
			<path
				d='M109.854 166.425C106.072 165.925 106.973 170.05 104.694 169.938C101.274 169.763 100.447 165.938 100.447 165.938C97.6164 169.226 98.5558 175.513 98.5558 175.513C98.5558 175.513 105.746 175.8 109.441 176.225C113.136 176.65 121.228 176.413 122.606 175.7C122.606 175.7 121.917 172.438 118.097 171.688C110.606 170.213 109.854 166.438 109.854 166.438V166.425Z'
				fill='#333333'
			/>
			<path
				d='M88.3991 39.1751C88.4366 40.2131 89.1882 42.9001 95.8773 43.3501C104.22 43.9251 102.616 38.7502 102.616 38.7502L102.078 33.0631C102.078 33.0631 88.8124 28.1501 88.6621 31.0631C88.612 32.0251 88.5744 33.1881 88.5369 34.3131C88.4617 36.6001 88.4241 38.7502 88.4241 38.7502C88.4241 38.7502 88.3865 38.9131 88.3991 39.1631V39.1751Z'
				fill='#F2CBA5'
			/>
			<path
				d='M91.8172 105.401C91.93 105.626 92.5187 107.063 93.3454 109.101C93.5584 109.626 93.7964 110.201 94.0344 110.813C96.5522 117.038 100.298 126.438 100.436 126.851C100.636 127.451 99.8215 163.451 99.8215 163.451C104.933 165.376 109.881 164.151 109.881 164.151C109.881 164.151 113.488 136.088 114.703 128.788C115.918 121.488 109.355 93.4011 109.254 92.2011C109.154 91.0011 109.78 88.5011 108.24 87.9011C101.626 85.3261 97.5793 86.601 95.1242 89.376C94.1722 90.451 93.4707 91.738 92.9446 93.113C90.9404 98.376 91.5792 104.938 91.8047 105.401H91.8172Z'
				fill='url(#paint4_linear_1600_1388)'
			/>
			<path
				d='M77.587 127.501C77.9126 129.138 83.7624 164.701 83.7624 164.701C89.2239 165.463 93.3701 163.763 93.3701 163.763C93.3701 163.763 93.2449 158.063 93.0945 151.338C93.0945 151.338 93.0945 151.313 93.0945 151.301C92.8816 142.088 92.6311 130.976 92.5559 130.126C92.4682 129.088 93.3701 118.038 94.034 110.813C94.3096 107.801 94.5476 105.451 94.6603 104.763L98.5685 93.0512L99.5581 90.1012C99.5581 90.1012 97.7669 89.8133 95.1238 89.4013C91.1655 88.7883 85.3032 87.8882 80.7185 87.2882C76.7853 86.7762 73.779 86.4632 73.7414 86.7132C73.6161 87.4762 77.2487 125.888 77.5744 127.526L77.587 127.501Z'
				fill='url(#paint5_linear_1600_1388)'
			/>
			<path
				d='M94.2229 28.8131C94.2229 28.8131 88.9618 31.5881 86.1935 28.2511C84.3271 26.0131 83.8511 20.7011 84.7655 17.5131C86.1559 12.6511 88.9743 10.4761 96.177 10.4761C103.091 10.4761 102.954 13.8381 104.394 19.2011C105.584 23.6381 105.259 27.3381 102.215 29.1511C99.3837 30.8381 97.2166 33.7761 97.2166 33.7761L94.2354 28.8261L94.2229 28.8131Z'
				fill='#7C7C7C'
			/>
			<path
				d='M100.786 33.7009C100.799 33.8129 100.198 38.7129 96.4773 38.8759C92.0305 39.0759 89.8008 34.2879 89.8384 31.3759C89.8759 28.4629 100.786 33.7009 100.786 33.7009Z'
				fill='#EDC297'
			/>
			<path
				d='M99.2451 15.55C100.085 15.9 101.826 16.738 102.665 18.838C102.928 19.488 103.091 20.25 103.116 21.163C103.229 25.013 103.517 30.45 102.089 33.063C100.661 35.675 96.4267 39.138 91.0529 34.125C85.6791 29.113 86.5309 20.625 86.8817 18.275C87.2199 15.938 93.3828 13.088 99.2451 15.538V15.55Z'
				fill='#F2CBA5'
			/>
			<path
				d='M86.0063 14.4129C88.8247 10.1759 92.7078 10.4009 95.426 10.3259C101.013 10.1629 102.453 9.96292 103.744 12.0129C105.034 14.0629 104.908 18.5629 98.044 19.1129C92.3571 19.5629 89.2881 18.2379 89.2881 18.2379C89.2881 18.2379 89.1504 21.8379 86.9207 23.1379C84.691 24.4509 83.6137 18.7129 86.0063 14.4129Z'
				fill='#7C7C7C'
			/>
			<path
				d='M88.5352 38.1258C89.5624 40.4128 93.1449 42.8758 97.4289 41.9378C102.164 40.9008 102.214 36.7008 102.251 35.3628C102.251 35.3628 103.278 37.3508 103.541 39.8878L111.107 50.0008C111.107 50.0008 111.107 52.1378 111.107 55.4258C111.057 66.2378 111.107 90.4128 111.107 90.4128C111.107 90.4128 99.3204 92.6508 85.6667 90.0628C80.3806 89.0628 76.4473 88.0878 76.4473 88.0878L88.5227 38.1008L88.5352 38.1258Z'
				fill='#005A55'
			/>
			<path
				d='M67.7168 93.6512C67.7168 93.6512 71.4121 62.4012 74.2681 47.0132C75.1074 42.4762 75.8715 39.3262 76.4602 38.7512C76.8861 38.3262 77.4373 37.9512 78.0636 37.6262C80.3809 36.4012 83.7129 35.7882 85.2913 35.5512C85.8424 35.4762 86.1681 35.4262 86.1681 35.4262C86.9948 35.0882 87.9218 34.3262 88.5481 34.3262L90.9782 43.7262C90.0763 63.9262 76.4602 99.4512 76.4602 99.4512L67.7168 93.6512Z'
				fill='url(#paint6_linear_1600_1388)'
			/>
			<path
				d='M79.4545 101.2C78.7405 100.625 77.8887 98.9252 76.8365 98.2252C75.7843 97.5252 74.6319 96.3752 74.3438 95.2252C74.2686 94.9382 74.4189 93.9382 73.7425 93.7252C71.7258 93.0882 67.2914 93.7002 67.2539 95.2752C67.2539 95.6252 67.5294 96.0252 67.8802 96.6252C67.9052 96.7002 68.0806 97.2502 68.2685 98.1382C68.6067 99.7252 68.9825 102.425 68.6819 105.588C68.519 107.288 69.2581 107.825 69.2581 107.825C69.1954 111.45 70.185 111.613 70.4105 111.6C70.4105 111.688 70.398 111.763 70.398 111.825C70.2852 113.15 71.826 113.988 72.2143 112.238C72.6026 110.488 73.1412 106.45 73.1788 105.813C73.2164 105.188 73.5797 105.425 73.73 106.15C73.7801 106.413 74.5943 110.563 74.7195 111.375C74.8448 112.175 76.5108 112.65 76.4357 110.525C76.373 108.4 75.3459 103.475 75.5964 102.613C75.8469 101.75 76.0724 100.788 76.0724 100.788C76.0724 100.788 78.3021 102.775 79.5297 102.738C80.7572 102.713 80.1935 101.775 79.4545 101.188V101.2Z'
				fill='#F2CBA5'
			/>
			<path
				d='M102.001 23.3132C102.088 23.0132 102.715 21.8512 103.516 22.5012C104.318 23.1512 103.892 26.4762 102.001 27.2382C100.109 28.0012 102.001 23.3132 102.001 23.3132Z'
				fill='#F2CBA5'
			/>
			<path
				d='M87.584 23.3132C87.4963 23.0132 86.87 21.8512 86.0683 22.5012C85.2667 23.1512 85.6925 26.4762 87.584 27.2382C89.4755 28.0012 87.584 23.3132 87.584 23.3132Z'
				fill='#F2CBA5'
			/>
			<path
				d='M66.3524 96.6749C66.4902 96.9499 68.8577 96.5129 70.9997 95.9499C72.8536 95.4749 74.5571 94.9129 74.507 94.6749C74.3943 94.1629 75.5592 69.6129 75.8849 68.5129C76.2106 67.4249 80.3318 58.5879 80.2441 58.0379C80.1689 57.6129 84.1773 44.3879 81.8224 39.3999C81.1585 37.9879 79.981 37.2249 78.0645 37.5999C74.8202 38.2379 70.8493 47.1249 68.319 56.5379C68.2188 56.8879 68.1311 57.2379 68.0434 57.5879C68.0434 57.6249 68.0309 57.6629 68.0184 57.6999C67.0038 61.6749 66.2647 65.6749 65.9516 69.1629C64.8618 81.2749 65.8639 95.6499 66.3649 96.6629L66.3524 96.6749Z'
				fill='#F3C000'
			/>
			<path
				opacity='0.2'
				d='M314.561 116.076C314.561 113.351 312.394 111.151 309.688 111.063C307.985 108.163 306.168 107.363 305.567 107.188C305.429 107.151 305.367 107.138 305.367 107.138C305.367 89.8008 263.241 86.9508 251.002 86.5128C248.923 86.4258 247.695 86.4128 247.695 86.4128C232.802 58.2878 218.284 51.7878 184.137 50.4008C183.298 49.7378 182.22 49.0128 181.82 48.8508C181.882 48.8508 181.945 48.8508 182.007 48.8628C183.648 49.0758 185.54 49.6258 185.69 48.8628C185.84 48.1008 183.974 47.2628 182.997 47.0378C182.02 46.8128 180.705 46.9258 178.262 46.8508C175.819 46.7758 173.627 46.5628 172.312 46.7878C171.673 46.8878 170.508 46.8508 169.293 46.7878V46.5758C169.293 46.5758 139.155 44.0258 130.862 41.3258C122.583 38.6258 116.921 36.4758 116.908 36.4628C115.53 36.1258 114.741 36.0128 113.313 35.9128C106.649 35.4508 102.202 34.3378 102.202 34.3378V34.4508L102.09 33.0878C102.703 31.9508 103.004 30.3008 103.129 28.4758C105.296 26.5008 105.447 23.1508 104.382 19.2128C104.119 18.2508 103.918 17.3628 103.705 16.5378C104.708 15.0008 104.432 13.1508 103.73 12.0378C102.44 9.98782 101 10.1878 95.413 10.3508C92.6948 10.4258 88.8242 10.2008 85.9932 14.4378C85.7678 14.8378 85.5924 15.2378 85.4295 15.6508C85.1665 16.2258 84.941 16.8508 84.7531 17.5258C83.8387 20.7128 84.3272 26.0258 86.1811 28.2628C86.6947 28.8878 87.296 29.2878 87.9348 29.5508C88.1478 30.0758 88.3858 30.5878 88.6613 31.0878C88.6112 32.0508 88.5737 33.2128 88.5361 34.3378C87.9098 34.3378 86.9828 35.1008 86.1561 35.4378C86.1561 35.4378 85.8179 35.4758 85.2792 35.5628C83.7134 35.8008 80.3689 36.4128 78.0515 37.6378C74.8072 38.2758 70.8364 47.1628 68.3061 56.5758C68.2059 56.9258 68.1182 57.2758 68.0305 57.6258C68.0305 57.6628 68.018 57.7008 68.0054 57.7378C66.9908 61.7128 66.2518 65.7128 65.9386 69.2008C65.0367 79.1508 65.5628 90.6128 66.0513 94.9628C62.8321 97.3008 58.9364 101.488 55.9927 108.951C55.9927 108.951 43.0405 117.513 42.4643 138.551C42.4267 139.701 42.4267 140.913 42.4768 142.163C42.5645 144.251 43.2284 146.188 44.3057 147.826C46.3349 150.863 49.8298 152.863 53.7254 152.863H75.5338C76.1601 159.226 79.3042 164.838 83.9765 168.701C82.6738 170.463 81.6341 173.613 78.2895 174.851C75.5463 175.863 75.6715 178.338 75.6715 178.338C79.5422 180.363 87.1331 179.113 89.4755 177.601C91.7052 176.176 94.5612 175.913 95.2126 175.476C95.2126 175.476 95.2126 175.475 95.0498 173.763C96.1521 173.95 97.2669 174.063 98.4068 174.088C98.4444 174.963 98.5321 175.538 98.5321 175.538C98.5321 175.538 105.722 175.825 109.417 176.25C113.113 176.676 121.205 176.438 122.583 175.726C122.583 175.726 121.894 172.463 118.073 171.713C115.631 171.238 113.914 170.501 112.699 169.751C117.434 166.388 120.867 161.338 122.107 155.476H254.785C257.053 166.126 266.522 174.113 277.871 174.113C290.636 174.113 301.02 164.001 301.458 151.376C303.049 150.726 304.427 149.988 305.467 149.126C306.243 148.326 307.02 147.426 307.772 146.426C309.362 144.276 310.778 141.688 311.755 138.563C312.619 135.826 313.145 132.688 313.145 129.088C313.145 125.488 312.92 122.613 312.544 120.126C313.759 119.213 314.561 117.763 314.561 116.126V116.076Z'
				fill='black'
			/>
			<defs>
				<radialGradient
					id='paint0_radial_1600_1388'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(172.865 149.845) scale(155.928 136.49)'
				>
					<stop stopColor='white' stopOpacity='0.1' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</radialGradient>
				<radialGradient
					id='paint1_radial_1600_1388'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(238.496 155.058) scale(67.0258 136.49)'
				>
					<stop />
					<stop offset='1' stopOpacity='0' />
				</radialGradient>
				<radialGradient
					id='paint2_radial_1600_1388'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(113.552 94133.8) scale(67.0258 136.49)'
				>
					<stop />
					<stop offset='1' stopOpacity='0' />
				</radialGradient>
				<linearGradient
					id='paint3_linear_1600_1388'
					x1='177.798'
					y1='159.313'
					x2='177.798'
					y2='45.663'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#008A80' />
					<stop offset='1' stopColor='#1AABA1' />
				</linearGradient>
				<linearGradient
					id='paint4_linear_1600_1388'
					x1='100.924'
					y1='86.1131'
					x2='111.627'
					y2='218.604'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#E6D1D1' />
					<stop offset='1' stopColor='#D2B7B2' />
				</linearGradient>
				<linearGradient
					id='paint5_linear_1600_1388'
					x1='92.105'
					y1='125.738'
					x2='74.7059'
					y2='125.738'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.15' stopColor='#E6D1D1' />
					<stop offset='1' stopColor='#D2B7B2' />
				</linearGradient>
				<linearGradient
					id='paint6_linear_1600_1388'
					x1='82.4728'
					y1='38.7132'
					x2='76.5226'
					y2='97.0782'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#F3C000' />
					<stop offset='1' stopColor='#DBAD00' />
				</linearGradient>
			</defs>
		</svg>
	),
)
